import { http } from '@tempo-sync/shared';
import type {
	Activities,
	ActivityHighlights,
	ActivitySummary,
	ActivitySummaryStats,
	Athlete,
	LLMActivityInsightResponse,
	PaginatedTrackRecommendations,
	Profile,
	TrackLeaderboardResponse
} from '@tempo-sync/shared/types';
import type { ChartData as StreamsResponse } from 'recharts/types/state/chartDataSlice';

import api from '../client';
import type { ApiResponse } from '../types';

export const apiService = {
	activity: {
		getActivities: (page?: number, limit?: number) =>
			api.get<ApiResponse<Activities>>(`/activity`, {
				params: { page: page, limit: limit }
			}),
		getSummaryById: (id: string) =>
			api.get<ApiResponse<ActivitySummary>>(`/activity/${id}/summary`),
		getAllActivitySummaries: () =>
			api.get<ApiResponse<ActivitySummaryStats[]>>('/activity/summary/overall'),
		getActivitiesPolylines: () =>
			api.get<ApiResponse<{ polyline: string; activityId: string }[]>>('/activity/polylines'),
		getActivityLLMInsights: (id: string) =>
			api.get<ApiResponse<LLMActivityInsightResponse>>(`/activity/${id}/llm-insights`),
		getActivityStreams: (id: string, streamTypes: string[]) =>
			api.post<ApiResponse<StreamsResponse>>(`/activity/${id}/streams`, {
				streamTypes
			}),
		getTrackLeaderboard: (id: string) =>
			api.get<ApiResponse<TrackLeaderboardResponse>>(`/activity/${id}/track-leaderboard`),
		getTrackRecommendations: (id: string, page?: number) =>
			api.get<ApiResponse<PaginatedTrackRecommendations>>(`/activity/${id}/track-recommendations`, {
				params: { page, limit: 3 }
			}),
		getActivityHighlights: (id: string) =>
			api.get<ApiResponse<ActivityHighlights>>(`/activity/${id}/highlights`)
	},
	athlete: {
		getMe: () => api.get<ApiResponse<{ athlete: Athlete }>>('/athlete')
	},
	sync: {
		getStatus: () => api.get<ApiResponse<{ status: string }>>('/sync/status')
	},
	profile: {
		getProfiles: () => api.get<ApiResponse<(Profile & { title: string })[]>>('/athlete/profiles')
	},
	spotify: {
		getTopArtists: () => api.get<ApiResponse<{ name: string; href: string }>>('/spotify/top-artist')
	},
	strava: {
		getAllActivitiesCount: () => api.get<ApiResponse<{ count: number }>>('/strava/activities/count')
	},

	map: {
		getHexPolygons: () =>
			http<{
				type: 'FeatureCollection';
				features: {
					geometry: {
						type: 'Polygon' | 'MultiPolygon';
						coordinates: number[][][] | number[][][][];
					};
				}[];
			}>(
				'https://nominatim.openstreetmap.org/search?q=Скопје&format=geojson&polygon_geojson=1&limit=1',
				{ headers: { 'User-Agent': 'tempo-sync' } }
			)
	}
};
